<button
  *ngIf="showClose"
  class="close-button"
  mat-icon-button
  (click)="clickClose()"
>
  <mat-icon fontIcon="Bosch-Ic-abort"></mat-icon>
</button>
<ng-content></ng-content>
